import BusinessEntity, { EntityManager, EntityManagerParameters } from '@xFrame4/business/base/BusinessEntity';
import { BusinessEntityFieldType } from '@xFrame4/business/base/Constants';
import { ManyToManyCollection } from '@xFrame4/business/base/ManyToManyCollection';
import { BusinessEntityWithTranslation, BusinessEntityTranslation, EntityWithTranslationManager, EntityTranslationManager, EntityWithTranslationManagerParameters } from '@xFrame4/business/base/BusinessEntityWithTranslation';

import EmailOptInFormTranslationGenerated from './EmailOptInFormTranslation.generated';
import EmailOptInFormTranslation from '../EmailOptInFormTranslation';


export class EmailOptInFormGeneratedEntityManager<BT extends EmailOptInFormTranslationGenerated, B extends EmailOptInFormGenerated<BT>> extends EntityWithTranslationManager<BT, B>
{
	translationEntityClass: any = EmailOptInFormTranslation;

    constructor(parameters: EntityWithTranslationManagerParameters<BT, B>)
    {
        super({
            name: parameters.name ?? 'EmailOptInForm',
            createEntity: parameters.createEntity,
            fields: [
				{ name: 'name', type: BusinessEntityFieldType.VarChar, isRequiredInput: true },
				{ name: 'isActive', type: BusinessEntityFieldType.Boolean },
				{ name: 'isDoubleOptIn', type: BusinessEntityFieldType.Boolean },
				{ name: 'isSendingToEmailMarketingToolEnabled', type: BusinessEntityFieldType.Boolean },
				{ name: 'emailMarketingToolListId', type: BusinessEntityFieldType.Integer },
				{ name: 'askForName', type: BusinessEntityFieldType.Boolean },
				{ name: 'askForPhone', type: BusinessEntityFieldType.Boolean },
				{ name: 'dateCreated', type: BusinessEntityFieldType.DateTime, isInput: false },
				{ name: 'dateModified', type: BusinessEntityFieldType.DateTime, isInput: false },
                ... parameters.fields ?? [],
            ],
            graphQlQueryAlias: parameters.graphQlQueryAlias ?? 'emailOptInForms',
            translationsCustomGraphQlFields: 'headline,subheadline,content,confirmationEmailSubject,confirmationEmailBodyIntro,confirmationEmailBodyOutro,confirmationEmailButtonText,formEmailLabel,formNameLabel,formPhoneLabel,formSubmitButtonText,redirectUrl,formSuccessMessage,formConfirmationEmailSentMessage,formConfirmationSuccessMessage',
        });
    }

}
export class EmailOptInFormGenerated<BT extends EmailOptInFormTranslationGenerated> extends BusinessEntityWithTranslation<BT>
{
	/** Internal identifier name for the form */
	name!: string;
	/** Whether the form is currently active and accepting submissions */
	isActive: boolean = true;
	/** Whether the form requires email confirmation before adding to list */
	isDoubleOptIn: boolean = false;
	/** Whether to send confirmed entries to external email marketing tool */
	isSendingToEmailMarketingToolEnabled: boolean = false;
	/** The list ID for the email opt-in form entries in the email marketing tool */
	emailMarketingToolListId: number | null = null;
	/** Whether to include name field in the form */
	askForName: boolean = false;
	/** Whether to include phone field in the form */
	askForPhone: boolean = false;
	/** When the form was created */
	dateCreated!: string;
	/** When the form was last modified */
	dateModified!: string;
	/** The name of the foreign key to the translated entity. */
	translationForeignKeyName: string = 'emailOptInForm';
	/** The primary language of the entity. */
	primaryLanguage: string = 'ro';

}

export default EmailOptInFormGenerated;